import { useGameStore } from '@/store/gameStore'
import { PageShell } from '../components/PageShell'
import { PageTabs } from '../components/PageTabs'
import { FeatureGate } from '../components/FeatureGate'
import { BroadcastHeader } from '../components/broadcast'
import { FEATURES } from '@/config/clubLevelConfig'
import { EconomyTabContent } from '../panels/EconomyTab'
import { MembershipsTabContent } from '../panels/MembershipsTab'
import { LoansTabContent } from '../panels/LoansTab'
import { SponsorshipsTabContent } from '../panels/SponsorshipsTab'
import { BarChart3, CreditCard, Landmark, Handshake, PiggyBank, Wallet } from 'lucide-react'

export function EconomyPage() {
  const { money, totalIncome, totalExpenses } = useGameStore()
  return (
    <PageShell
      pageId="economy"
      title="Dpto. Financiero"
      icon={<PiggyBank size={22} />}
    >
      <BroadcastHeader
        title={`${money.toLocaleString('es-ES')}€`}
        competition="Tesorería del club"
        icon={Wallet}
        meta={
          <>
            <span className="chip-angled tone-gold">+{totalIncome.toLocaleString('es-ES')}€ ingresos</span>
            <span className="chip-angled">-{totalExpenses.toLocaleString('es-ES')}€ gastos</span>
          </>
        }
      />
      <PageTabs
        tabs={[
          {
            label: 'Resumen',
            icon: <BarChart3 size={16} />,
            content: <EconomyTabContent />,
          },
          {
            label: 'Socios',
            icon: <CreditCard size={16} />,
            content: <MembershipsTabContent />,
          },
          {
            label: 'Prestamos',
            icon: <Landmark size={16} />,
            content: <LoansTabContent />,
          },
          {
            label: 'Patrocinios',
            icon: <Handshake size={16} />,
            content: <FeatureGate feature={FEATURES.SPONSORSHIPS}><SponsorshipsTabContent /></FeatureGate>,
          },
        ]}
      />
    </PageShell>
  )
}
